import axios from "../axios/axios";
import { setFactor, setFactors } from "../store/actions/factorAction";
import { appSetLoading, appSetSendingRequest } from "../store/actions/appAction";
import { apiSetAlert } from "./appApi";
import { selectTableItems } from "../store/actions";
import { errorDispatcher, formatDate, getOptionsQuery, setSelectItemLabels } from "../helpers";
import { setTableData } from "../store/actions/dataTableAction";
import { setEditItem, updateTransaction } from "../store/actions/formAction";
import fileDownload from "js-file-download";
import { DateToString } from "components/Reports/DateFilter";

export const apiGetFactorsExcel = (token, factorType, selectedIds) => (dispatch) => {
    let url = `factors/excel/export?factorType=${factorType.replace("IsDraft", "")}`;
    if (selectedIds && selectedIds.length > 0) {
        url += `&ids=[${selectedIds}]`;
    }
    if (factorType.includes("IsDraft")) {
        url += `&isDraft=1`
    }
    dispatch(appSetLoading());
    axios
        .get(url, {
            headers: { Authorization: `Bearer ${token}` },
            responseType: "blob",
        })
        .then((response) => {
            dispatch(appSetLoading(false));
            const now = DateToString(Date.now()).replace("/", "_");
            const fileName = factorType ? `${factorType}s_${now}` : `factors_${now}`;
            fileDownload(response.data, `${fileName}.xlsx`);
        })
        .catch((error) => {
            errorDispatcher(error, dispatch);
        });
};

export const apiGetFactor = (factorId, factorType, token, callback) => (dispatch) => {
    dispatch(appSetLoading(true));
    axios
        .get(`factors/${factorId}?factorType=${factorType || ""}`, {
            headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
            const factor = response.data.factor;

            dispatch(setFactor(factor));

            if (callback) {
                callback(factor);
            } else {
                dispatch(setEditItem(factor));
            }
            dispatch(appSetLoading(false));
        })
        .catch((error) => {
            errorDispatcher(error, dispatch, false);
        });
};

export const apiGetFactors =
    ({ pagination, token, key, sort, search }) =>
        (dispatch, getState) => {
            const Token = token || getState().businessReducer.business?.token;
            let options = getOptionsQuery(pagination, search, sort);

            let factorType = key;
            let url = `/factors/list`;
            let params = {
                factorType: key,
            };

            if (factorType !== "all") {
                params = { ...params, factorType: typeof factorType === "string" ? factorType : "sale" };
            }

            // if (factorType === "estimate") {
            //   options = {
            //     ...options,
            //     column: "status",
            //     columnType: "string",
            //     filterType: "1",
            //     primarySearch: "پیش نویس",
            //   };
            //   params = { ...params, factorType: "sale" };
            // }

            dispatch(appSetLoading());
            axios
                .post(url, options, {
                    headers: { Authorization: `Bearer ${Token}` },
                    params,
                })
                .then((response) => {
                    dispatch(setTableData(response.data.factors, response.data.paginate, response.data.sumAmount, response.data.sumAmountFinal
                    ));
                    // dispatch(setFactors(response.data.factors));
                    dispatch(appSetLoading(false));
                })
                .catch((error) => {
                    errorDispatcher(error, dispatch);
                });
        };

export const apiFactorsList =
    (token, factorTypes, type = "transaction", personId, cb) =>
        (dispatch) => {
            const params = {
                factorTypes,
                type,
                personId,
            };
            dispatch(appSetLoading());
            axios
                .get(`/factors/list/active`, {
                    headers: { Authorization: `Bearer ${token}` },
                    params,
                })
                .then((response) => {
                    const factors = setSelectItemLabels(response.data.factors, "id", "title");
                    dispatch(setFactors(factors));
                    dispatch(appSetLoading(false));
                    cb && cb(factors);
                })
                .catch((error) => {
                    errorDispatcher(error, dispatch);
                });
        };

export const apiPersonFactorsList =
    ({ token, factorTypes, personId }) =>
        (dispatch) => {
            dispatch(appSetLoading());
            axios
                .get(`/factors/list/active?factorTypes=${factorTypes}&personId=${personId}&type=transaction`, {
                    headers: { Authorization: `Bearer ${token}` },
                })
                .then((response) => {
                    const factors = setSelectItemLabels(response.data.factors, "id", "title");
                    dispatch(setFactors(factors));
                    dispatch(appSetLoading(false));
                })
                .catch((error) => {
                    errorDispatcher(error, dispatch);
                });
        };

export const apiDeleteFactors = (selectedIds, token, type, callback, items) => (dispatch) => {
    const factorIds = items.map(row => { return { id: row.id, type: row.type } });
    const factorType = type.key;

    dispatch(appSetLoading());
    dispatch(appSetSendingRequest());
    axios
        .delete(`/factors/multiple/delete`, {
            headers: { Authorization: `Bearer ${token}` },
            data: { factorIds, factorType },
        })
        .then((response) => {
            dispatch(selectTableItems([]));
            dispatch(apiSetAlert(response.data.message, "success"));
            if (callback) callback();
        })
        .catch((error) => {
            errorDispatcher(error, dispatch);
        });
};

export const apiSaveFactor = (form, token, callback, nextStep, fd, cb) => (dispatch, getState) => {
    const businessCurrencyId = getState().businessReducer.business.business.default_currency_id;
    const factorCurrency = form.factorCurrency;
    let currencyExchange = 1;

    if (factorCurrency && factorCurrency.id !== businessCurrencyId) {
        currencyExchange = getState().currencyReducer.businessCurrencies.find(
            (bc) => bc.id === form.factorCurrency.id
        ).currencyExchange;
    }

    const products = [];

    form.items?.map((i) => {
        const discount =
            i.discountType === "percent" && i.discount && i.price
                ? +((i.discount / 100) * i.price)
                : +(i.discount ?? 0);
        if (i.product) {
            products.push({
                productId: i.product.id,
                unit: i.unit === "secondary" ? i.product.subUnit ?? i.product.unit : i.product.unit,
                quantity: +i.quantity,
                price: +i.price,
                tax: +(+(+i.tax / 100) * (+i.price - discount)) * +i.quantity,
                description: i.description,
                discount: discount * +i.quantity,
            });
        }
    });

    const formData = {
        main: {
            accountingCode: form.accountingCodeType ? null : form.accountingCode ?? null,
            title: form.title ?? null,
            description: form.description ?? null,
            reference: form.reference ?? null,
            status: form.isDraft ? "پیش نویس" : "تایید شده", // پیش نویس و تایید شده و مرجوع شده
            date: form.storeDate ? formatDate(form.storeDate) : null, // فارسی
            dueDate: form.paymentDate ? formatDate(form.paymentDate) : null, // فارسی
            transferPrice: form.transportActive ? parseInt(form.transport) : null,
            PersonId: form.person?.id ?? null,
            ProjectId: form.project?.id ?? null,
            BranchId: form.branch?.id ?? null,
            SellerId: form.seller?.id ?? null,
            sellerCommission: form.sellerCommission ?? null,
            commissionType: form.commissionType ?? null,
            WarehouseId: form.warehouse?.id ?? null,
            factorType:
                form.factorTab + (form.factorTab !== "waste" ? (form.isReturnedFactor ? "Return" : "") : ""),
            currencyId: form.factorCurrency?.id ?? null,
            currencyExchange,
        },
        products: products,
    };

    dispatch(appSetSendingRequest(true));
    dispatch(appSetLoading());
    axios
        .post("/factors", fd || formData, {
            headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
            dispatch(appSetLoading(false));
            dispatch(apiSetAlert(response.data.message, "success"));
            const factor = response.data.factor;
            if (cb) cb(response.data);

            if (callback) {
                dispatch(
                    apiGetFactor(factor.id, factor.type, token, (factor) => {
                        nextStep && dispatch(updateTransaction("transactionFactor", factor));
                        callback(factor);
                    })
                );
            }
        })
        .catch((error) => {
            errorDispatcher(error, dispatch);
        });
};
const sendRequest = async (fullData, getState, callBack, index) => {
    const token = getState().businessReducer.business?.token;
    for (const ix in fullData) {
        if (ix > index) {
            const row = fullData[ix]
            row["isExcel"] = true
            const res = await axios.post(`/factors`, row, {
                headers: { Authorization: `Bearer ${token}` },
            }).catch(error => {
                fullData[ix].status = "error"
                fullData[ix].error = error.response.data.message;
            })

            if (res) {
                fullData[ix].status = "saved"
            }

        }
    }
    callBack(fullData)
}
export const apiSaveFactorByExcel = (forms, token, callback) => (dispatch, getState) => {
    const idFilter = []
    const fullData = []
    forms.map((row, ix, data) => {
        const newRow = row.main
        if (idFilter.indexOf(newRow.voucherHeaderId) === -1) {
            idFilter.push(newRow.voucherHeaderId)
            const filterData = data.filter(x => x.main.voucherHeaderId === newRow.voucherHeaderId)
            const neWAcount = { main: {}, products: [] }
            filterData.map(filRoww => {
                const filRow = filRoww.main
                if (Object.keys(neWAcount.main).length === 0) {
                    neWAcount.main = {
                        PersonId: filRow.PersonId,
                        personAccountingCode: filRow.personAccountingCode,
                        date: filRow.date,
                        commissionType: typeof filRow.prsentSellerCommission !== "undefined" && filRow.prsentSellerCommission  ? "percent" : 'number',
                        sellerCommission: filRow?.prsentSellerCommission ? filRow?.prsentSellerCommission : filRow?.currencySellerCommission ? filRow?.currencySellerCommission : 0,
                        currencyId: filRow.currencyId,
                        dueDate: filRow.dueDate,
                        accountingCode: filRow.accountingCode,
                        "WarehouseId": filRow.WarehouseId,
                        "WarehouseAccountingCode": filRow.WarehouseAccountingCode,
                        reference: filRow.reference,
                        factorType: "sale",
                        description: filRow.descriptionHeader,
                        SellerId: filRow.SellerId,
                        sellerAccountingCode: filRow.sellerAccountingCode,
                        BranchId: filRow.BranchId,
                        // branchAccountingCode: filRow.branchAccountingCode,
                        ProjectId: filRow.ProjectId,
                        // projectAccountingCode: filRow.projectAccountingCode,
                        taxType: filRow.taxType,
                        title: filRow.title,
                        transferPrice: filRow.transferPrice,
                        status: "تایید شده",
                    }
                }
                neWAcount.products.push({
                    "productAccountingCode": filRow.productAccountingCode,
                    "productId": filRow.productId,
                    "WarehouseId": filRow.WarehouseId,
                    "WarehouseAccountingCode": filRow.WarehouseAccountingCode,
                    "descriptionItem": filRow.descriptionItem,
                    "quantity": filRow.quantity,
                    "price": filRow.price,
                    "unit": filRow.unit,
                    "tax": filRow.tax,
                    "discount": filRow.discount,
                })
            })
            fullData.push(neWAcount)

        }

    })
    sendRequest(fullData, getState, callback, -1)
}
export const apiSaveFactorBuyByExcel = (forms, token, callback) => (dispatch, getState) => {
    const idFilter = []
    const fullData = []
    forms.map((row, ix, data) => {
        const newRow = row.main
        if (idFilter.indexOf(newRow.voucherHeaderId) === -1) {
            idFilter.push(newRow.voucherHeaderId)
            const filterData = data.filter(x => x.main.voucherHeaderId === newRow.voucherHeaderId)
            const neWAcount = { main: {}, products: [] }
            filterData.map(filRoww => {
                const filRow = filRoww.main
                if (Object.keys(neWAcount.main).length === 0) {
                    neWAcount.main = {
                        PersonId: filRow.PersonId,
                        personAccountingCode: filRow.personAccountingCode,
                        date: filRow.date,
                        commissionType: typeof filRow.prsentSellerCommission !== "undefined" && filRow.prsentSellerCommission  ? "percent" : 'number',
                    //    sellerCommission: filRow?.prsentSellerCommission ? filRow?.prsentSellerCommission : filRow?.currencySellerCommission ? filRow?.currencySellerCommission : 0,
                        currencyId: filRow.currencyId,
                        dueDate: filRow.dueDate,
                        accountingCode: filRow.accountingCode,
                        reference: filRow.reference,
                        factorType: "buy",
                        description: filRow.descriptionHeader,
                        "WarehouseId": filRow.WarehouseId,
                        "WarehouseAccountingCode": filRow.WarehouseAccountingCode,
                       // SellerId: filRow.SellerId,
                        sellerAccountingCode: filRow.sellerAccountingCode,
                        BranchId: filRow.BranchId,
                        // branchAccountingCode: filRow.branchAccountingCode,
                        ProjectId: filRow.ProjectId,
                        // projectAccountingCode: filRow.projectAccountingCode,
                      //  taxType: filRow.taxType,
                        title: filRow.title,
                        transferPrice: filRow.transferPrice,
                        status: "تایید شده",
                    }
                }
                neWAcount.products.push({
                    "productAccountingCode": filRow.productAccountingCode,
                    "productId": filRow.productId,
                    "WarehouseId": filRow.WarehouseId,
                    "WarehouseAccountingCode": filRow.WarehouseAccountingCode,
                    "descriptionItem": filRow.descriptionItem,
                    "quantity": filRow.quantity,
                    "price": filRow.price,
                    "unit": filRow.unit,
                    "tax": filRow.tax,
                    "discount": filRow.discount,
                })
            })
            fullData.push(neWAcount)

        }

    })
    sendRequest(fullData, getState, callback, -1)
}
export const apiUpdateFactor =
    (factorId, form, token, callback, nextStep, fd, cb) => (dispatch, getState) => {
        const businessCurrencyId = getState().businessReducer.business.business.default_currency_id;
        const factorCurrency = form.factorCurrency;
        let currencyExchange = 1;

        if (factorCurrency && factorCurrency.id !== businessCurrencyId) {
            currencyExchange = getState().currencyReducer.businessCurrencies.find(
                (bc) => bc.id === form.factorCurrency.id
            ).currencyExchange;
        }

        const products = [];

        form.items?.map((i) => {
            if (i.product) {
                products.push({
                    productId: i.product.id,
                    unit: i.unit === "secondary" ? i.product.subUnit ?? i.product.unit : i.product.unit,
                    quantity: +i.quantity,
                    price: +i.price,
                    tax: +(+(+i.tax / 100) * +i.price) * +i.quantity,
                    description: i.description,
                    discount:
                        (i.discountType === "percent" && i.discount && i.price
                            ? +((i.discount / 100) * i.price)
                            : +i.discount ?? 0) * +i.quantity,
                });
            }
        });

        const formData = {
            main: {
                accountingCode: form.accountingCodeType ? null : form.accountingCode?.toString() ?? null,
                title: form.title ?? null,
                description: form.description ?? null,
                reference: form.reference ?? null,
                status: form.isDraft ? "پیش نویس" : "تایید شده", // پیش نویس و تایید شده و مرجوع شده
                date: form.storeDate ? formatDate(form.storeDate) : null, // فارسی
                dueDate: form.paymentDate ? formatDate(form.paymentDate) : null, // فارسی
                transferPrice: form.transportActive ? parseInt(form.transport) : null,
                PersonId: form.person?.id ?? null,
                ProjectId: form.project?.id ?? null,
                BranchId: form.branch?.id ?? null,
                SellerId: form.seller?.id ?? null,
                sellerCommission: form.sellerCommission ?? null,
                commissionType: form.commissionType ?? null,
                WarehouseId: form.warehouse?.id ?? null,
                factorType:
                    form.factorTab + (form.factorTab !== "waste" ? (form.isReturnedFactor ? "Return" : "") : ""),
                currencyId: form.factorCurrency?.id ?? null,
                currencyExchange,
            },
            products: products,
        };
        dispatch(appSetSendingRequest(true));
        axios
            .put(`factors/${factorId}`, fd || formData, {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then((response) => {
                dispatch(apiSetAlert(response.data.message, "success", false));
                dispatch(setEditItem(null));
                if (cb) cb(response.data);
                if (callback) {
                    dispatch(
                        apiGetFactor(factorId, formData.main.factorType, token, (factor) => {
                            nextStep && dispatch(updateTransaction("transactionFactor", factor));
                            callback(factor);
                        })
                    );
                }
            })
            .catch((error) => {
                errorDispatcher(error, dispatch);
            });
    };

export const apiSetFactorApproved =
    ({ id, approved, token }) =>
        (dispatch, getState) => {
            const tableData = getState().dataTableReducer?.items;
            const url = "/factors/update/approve";
            axios
                .put(url, { factorIds: [id], approved }, { headers: { Authorization: `Bearer ${token}` } })
                .then((res) => {
                    const newTableData = tableData.map((x) => {
                        if (x.id === id) {
                            return { ...x, approved };
                        }
                        return x;
                    });
                    const paginationReducer = getState().dataTableReducer.paginate

                    dispatch(setTableData(newTableData, paginationReducer));
                })
                .catch((error) => {
                    errorDispatcher(error, dispatch);
                });
        };

export const apiGetFactorTransaction = async (id, token, dispatch) => {

    const url = `factors/${id}/transaction`;
    try {
        dispatch(appSetLoading(true));

        const res = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
        dispatch(appSetLoading(false));

        return res.data;
    } catch (error) {
        const message = error.response?.data?.message;
        // if (message) dispatch(appSetAlert(message, "error"));
    }
};
